export default {
  see: 'View',
  report_info: 'Report Information',
  report_title: 'Report',
  report: 'Report',
  job: {
    reasons: {
      fraudulent_offer: 'Fraudulent offer',
      inappropriate_content: 'Inappropriate content',
      false_information: 'False or misleading information',
      other: 'Other',
    },
  },
  profile: {
    reasons: {
      fake_identity: 'Fake identity',
      inappropriate_or_offensive: 'Inappropriate or offensive content',
      spam_or_scam: 'Spam or scam',
      other: 'Other',
    },
  },
  review: {
    reasons: {
      abusive_review: 'Abusive or defamatory review',
      spam: 'Spam',
      conflict_of_interest: 'Conflict of interest',
      other: 'Other',
    },
  },
  quote: {
    reasons: {
      fraudulent_quote: 'Fraudulent quote',
      inappropriate_content: 'Inappropriate content',
      harassment: 'Scam or harassment',
      other: 'Other',
    },
  },
  quote_request: {
    reasons: {
      fraudulent_request: 'Fraudulent request',
      inappropriate_content: 'Inappropriate content',
      harassment: 'Scam or harassment',
      other: 'Other',
    },
  },
  reportPlaceholder: 'Select an option',
  report_content: 'Make report',
  report_this_offer: 'Report this offer',
  report_this_quote: 'Report this quote',
  report_this_user: 'Report this user',
  report_this_review: 'Report this review',
  report_this_quote_request: 'Report this quote request',
  report_this_issue: 'Report an issue',
  description:
    'Please select a reason for reporting. This helps us maintain a safe and trustworthy platform.',
  reason_label: 'Reason for reporting',
  other_reason_label: 'Explain your report',
  link_copied: 'Link successfully copied',
  copy_link: 'Copy link',
  additional_details_label: 'additional details (optional)',
  additional_details_placeholder: 'Add additional details if necessary ...',
  report_reasons: {
    fraudulent_offer: 'Fraudulent offer',
    inappropriate_content: 'Inappropriate content',
    false_information: 'False or misleading information',
    other: 'Other',
    fake_identity: 'Fake identity',
    inappropriate_or_offensive: 'Inappropriate or offensive content',
    spam_or_scam: 'Spam or scam',
    abusive_review: 'Abusive or defamatory review',
    spam: 'Spam',
    conflict_of_interest: 'Conflict of interest',
    fraudulent_request: 'Fraudulent request',
    harassment: 'Scam or harassment',
    fraudulent_quote: 'Fraudulent quote',
    product_bug: 'Product bug',
  },
  has_reported: {
    job: 'has reported an offer.',
    profile: 'has reported a user.',
    review: 'has reported a review.',
    quote: 'has reported a quote.',
    quote_request: 'has reported a quote request.',
    issue: 'has reported a product issue.',
  },
  issue: {
    footer_link: 'Report an issue',
    modal_title: 'Report an issue',
    modal_description:
      'Tell us what went wrong. We automatically include this page so our admins can reproduce the bug.',
    anonymous_reporter: 'Anonymous reporter',
    email_label: 'Your email',
    email_placeholder: 'name@email.com',
    reporter_label: 'Reporter',
    reporter_email_label: 'Reporter email',
    title_label: 'Issue title',
    title_placeholder: 'Short summary of the problem',
    description_label: 'Issue description',
    description_placeholder: 'Describe what happened and what you expected.',
    page_label: 'Page where issue occurred',
    attachments_label: 'Screenshots (optional)',
    add_screenshot: 'Add screenshot',
    attachments_hint: '{{count}}/{{max}} screenshots selected',
    remove_attachment: 'Remove',
    submit_button: 'Send issue',
    submit_success: 'Issue reported successfully.',
    submit_error: 'Unable to send the issue report. Please try again.',
    validation: {
      max_attachments: 'You can upload up to {{max}} screenshots.',
      images_only: 'Only image files are allowed for screenshots.',
      file_size_max: 'Each screenshot must be 10MB or less.',
      invalid_email: 'Please enter a valid email address.',
      title_required: 'Issue title is required.',
      description_required: 'Issue description is required.',
      upload_failed: 'Failed to upload attachment. Please try again.',
    },
  },
  other_reason_placeholder: 'Provide details about the reason for reporting...',
  already_submitted_warning: 'You have already submitted a report for this item.',
} as const;
